import BaseModelInstance from './base.model'
import { PointOverride as ModelDefinition } from './model-definitions'

class PointOverride extends BaseModelInstance {
  afterSet = (key, value) => {}

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default PointOverride
